import { ReactNode } from "react";
import { Checkbox } from "react-aria-components";

interface AccessibleCheckboxProps {
  label?: string; // For the label text
  checked?: boolean; // Controlled checked state
  onChange?: (checked: boolean) => void; // Change handler
  children?: ReactNode; // Additional children
}

const AccessibleCheckbox = ({ label, checked, onChange, children, ...props }: AccessibleCheckboxProps) => (
  <Checkbox
    {...props}
    isSelected={checked}
    onChange={(isSelected) => onChange?.(isSelected)}
    className='tw-flex tw-cursor-pointer tw-items-center tw-gap-3 tw-py-[2px] tw-text-base'
    aria-label={label ? label : undefined}
    aria-checked={checked}
  >
    {({ isSelected }) => (
      <>
        <div
          className={`
              tw-flex tw-h-[18px] tw-w-[18px] tw-items-start tw-justify-center tw-rounded-[3px] tw-border-[1.75px] tw-border-solid tw-border-[#4D4D4D]  tw-pb-0.5 tw-transition-all tw-duration-200
              ${
                isSelected
                  ? "tw-border-blue tw-bg-blue-dark"
                  : "tw-bg-white hover:tw-border-blue-dark focus:tw-border-blue-dark"
              }
            `}
        >
          {isSelected && (
            <svg
              className='tw-h-4 tw-w-4 tw-stroke-[2.5px] tw-text-white'
              viewBox='0 0 16 16'
              fill='none'
              stroke='currentColor'
              aria-hidden='true'
            >
              <path d='M2 8l4.5 4.5 8-8' />
            </svg>
          )}
        </div>
        <span className='tw-text-gray-700 tw-font-lato tw-select-none tw-text-base'>{label || children}</span>
      </>
    )}
  </Checkbox>
);
export default AccessibleCheckbox;
